import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import type { ModuleState } from '@redux/modules/types'

import TrainingLessonEditRoutes from './routes'

const TrainingLessonEdit = () => {
  const { trainingLessonId } = useNumericParams()

  useReduxAction(
    'trainingLessons',
    'loadTrainingLesson',
    {
      entityId: trainingLessonId,
    },
    [trainingLessonId],
    {
      dispatchAction: (action: Function, requestOptions) => action(trainingLessonId, requestOptions),
      shouldPerformFn: ({ loading }: ModuleState) => !!trainingLessonId && !loading,
    },
  )

  return (
    <TrainingLessonEditRoutes />
  )
}

export default TrainingLessonEdit
